<template>
    <div class="box">
      <form class="form" v-on:submit.prevent="handlePolicy">
        <AddPolicyFields />
        <div class="form-wrap form-submit">
            <div>
              <button type="submit" class="button">
                Add Policy
              </button>
            </div>
        </div>
      </form>
    </div>
</template>
<script>

import AddPolicyFields from '@/components/AddPolicyFields.vue'
import { CancellationMixin } from './CancellationMixin';

export default {
    name: 'CancellationCreate',
    mixins:[CancellationMixin],
    components: {
        AddPolicyFields,
    },
    data() {
        return {
            newPolicy: {},  
        }
    },
    methods:
    {
        handlePolicy()
        {
            this.newPolicy.handle_tag = 'add';
            this.addPolicy(this.newPolicy)
        }
    }
}
</script>